// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__28PaU","left":"InfoRow_left__Ga51b"};